import axiosInstance from "./axios.config";

class AuthService {
  async login(email, password) {
    try {
      const response = await axiosInstance.post("/login", {
        email,
        password,
      });

      return response.data;
    } catch (error) {
      throw error?.response?.data?.message || "An error occurred during login";
    }
  }

  async register(email, password, name) {
    try {
      const response = await axiosInstance.post("/register", {
        email,
        password,
        name,
      });
      return response.data;
    } catch (error) {
      throw (
        error.response?.data?.message || "An error occurred during registration"
      );
    }
  }

  async forgotPassword(email) {
    try {
      const response = await axiosInstance.post("/password-reset", {
        email,
      });
      return response.data;
    } catch (error) {
      throw (
        error.response?.data?.error || "An error occurred during password reset"
      );
    }
  }

  async resetPassword(token, newPassword) {
    try {
      const response = await axiosInstance.post("/password-reset-confirm", {
        token,
        new_password: newPassword,
      });
      return response.data;
    } catch (error) {
      throw (
        error.response?.data?.error ||
        "An error occurred during password reset confirmation"
      );
    }
  }

  logout() {
    localStorage.removeItem("user");
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem("user"));
  }

  getToken() {
    const user = this.getCurrentUser();
    return user?.access_token;
  }

  isAuthenticated() {
    return !!this.getToken();
  }
}

export default new AuthService();
